import { Pano } from "../Pano.js";

export enum ControlPosition {
    LEFT = "left",
    RIGHT = "right",
    SEEK = "seek",
    OVERLAY = "overlay",
    CENTER = "center"
}

export class BaseControl {

    // public onVisibilityChanged = e5.Signal.create<[boolean]>();
    // public element: HTMLElement;
    public pano: Pano;
    // public position: ControlPosition = null;

    protected _video: HTMLVideoElement;

    constructor(pano: Pano) {
        this.pano = pano;
        this._video = pano.video;
        // this.position = position;
        // this.element = document.createElement("div");
        // this.element.classList.add("base-control");
    }

    // public get visible(): boolean {
    //     return !this.element.classList.contains("hidden");
    // }

    // public set visible(v: boolean) {
    //     this.element.classList.toggle("hidden", !v);
    //     this.onVisibilityChanged.dispatch(v);
    // }
}